namespace $.$$ {

	$mol_style_define( $shm_projects_docs, {

		Toc_page: {
			Title: {
				minHeight: 0,
				padding: 0,
			},
		},

		Modes: {
			alignItems: 'center',
			gap: 0,
			minHeight: '2rem',
		},

	} )

}
